import React, { useEffect, useState, useRef } from "react";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import classNames from "classnames";
import "./index.scss";

import { getConvertedCloudUrl } from "../../../utils/image-util";

const ImageEditControl = ({ t, img, isFullHeight, onLoadImage, disabled }) => {
  const fileInput = useRef();
  const [image, setImage] = useState(null);

  const handleOnImageLoad = files => {
    if(disabled){
      return;
    }

    const file = files[0];

    if (!file || file.type.indexOf("image") < 0) {
      toast.error(t("settings.AVATAR_LOADING_ERROR"));
      return;
    }

    const fr = new FileReader();
    fr.onload = () => {
      if (fr.result) {
        setImage(fr.result);
        if (onLoadImage) {
          onLoadImage(fr.result);
        }
      }
    };

    fr.readAsDataURL(file);
  }

  useEffect(()=> {
    if(img !== image) {
      setImage(isFullHeight ? img : getConvertedCloudUrl(img));
    }
  }, [isFullHeight, img, image]);

  return (
    <div className={classNames("imageEditControl", { full: isFullHeight })}>
      {image && (<img src={image} alt="imageEdit" className={classNames("imageEdit")} />)}
      {!image && <div className={classNames("imageEmpty")} />}
      <div className={classNames("editControl")}>
        <span className={classNames("editControlLabel")}>
          {t("settings.personalSettings.personalSettings.AVATAR_CHANGE_BUTTON")}
        </span>
        <input ref={fileInput} type="file" disabled={disabled} onChange={e => handleOnImageLoad([...e.target.files])} />
      </div>
    </div>
  );
}

export default withTranslation()(ImageEditControl);
